import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementsSubscriptions } from '@api/networkElements';

import { actionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_SUBSCRIPTION_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsSubscriptionsReturned {
	subscribeOptions: TSelectOption[];
	isLoadingSubscribeOptions: boolean;
}

const useQueryNetworkElementsSubscriptions = (): IUseQueryNetworkElementsSubscriptionsReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_SUBSCRIPTION_OPTIONS],
		select: actionsFormatted,
		queryFn: getNetworkElementsSubscriptions,
		...refetchOptions,
	});

	return {
		subscribeOptions: data || [],
		isLoadingSubscribeOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementsSubscriptions;
